import { render, staticRenderFns } from "./storeNBNum.vue?vue&type=template&id=46fab667&"
import script from "./storeNBNum.vue?vue&type=script&lang=js&"
export * from "./storeNBNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports